export default "__VITE_ASSET__M7biL6nf__"